import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const Field = ({
  children,
  ['data-test-id']: dataTestId
}) => /*#__PURE__*/_jsx(View, {
  "data-test-id": dataTestId,
  marginBlockEnd: "100",
  as: "div",
  children: children || null
});
export default Field;